import { Container } from '@cgs/wge';
import { ILoadingScreen } from '@cgs/machines';
import {
  TRIFECTA_SDK_ADAPTER_TOKEN,
  TrifectaSDKAdapter,
  TrifectaSDKLoadingOverlay,
} from '../sdk/trifecta-sdk.adapter';

export class TrifectaLoadingScreen implements ILoadingScreen {
  protected readonly trifectaSDKAdapter: TrifectaSDKAdapter;

  private loadingOverlay: TrifectaSDKLoadingOverlay | null = null;

  private stepsCount: number = 0;
  private currentStep: number = 0;

  constructor(container: Container) {
    this.trifectaSDKAdapter = container.resolve<TrifectaSDKAdapter>(TRIFECTA_SDK_ADAPTER_TOKEN);
  }

  public async render(): Promise<void> {
    await this.trifectaSDKAdapter.initialize();
    this.loadingOverlay = await this.trifectaSDKAdapter.showLoadingOverlay();
    this.updateProgress(0);
  }

  public updateProgress(progress: number): void {
    this.loadingOverlay?.setProgress(Math.max(0, Math.min(1, progress)));
  }

  public addSteps(steps: number): void {
    this.stepsCount += steps;
  }

  public step(): void {
    const progress = this.currentStep >= this.stepsCount ? 1 : ++this.currentStep / this.stepsCount;
    this.updateProgress(progress);
  }

  public async finish(): Promise<void> {
    this.trifectaSDKAdapter.hideContainer();
    void this.trifectaSDKAdapter.showGameOverlay();
  }

  public deinitialize(): void {
    //
  }
}
